import { render, staticRenderFns } from "./SkeletonFeaturedSlide.vue?vue&type=template&id=6bac18c0"
import script from "./SkeletonFeaturedSlide.vue?vue&type=script&lang=js"
export * from "./SkeletonFeaturedSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports